import { Center } from '@zorro/web/design-system';

import { SVGIconProps } from '../types';

const CARDS = [
  { y: 0, topPillWidth: 46 },
  { y: 52, topPillWidth: 27 },
  { y: 104, topPillWidth: 51 },
];

export const BenefitsSetupInProgressIllustration = ({
  style,
}: SVGIconProps) => {
  return (
    <Center style={style}>
      <svg
        width="164"
        height="144"
        viewBox="0 0 164 144"
        fill="none"
        overflow="visible"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <filter
            id="benefits_setup_card_shadow"
            x="-25%"
            y="-100%"
            width="150%"
            height="300%"
          >
            <feDropShadow
              dx="6"
              dy="6"
              stdDeviation="5"
              floodColor="black"
              floodOpacity="0.06"
            />
          </filter>
        </defs>
        {CARDS.map(({ y, topPillWidth }) => (
          <g key={y} transform={`translate(0, ${y})`}>
            <rect
              x="0.5"
              y="0.5"
              width="163"
              height="39"
              rx="7.5"
              fill="white"
              stroke="#EDEFF6"
              filter="url(#benefits_setup_card_shadow)"
            />
            <rect
              x="8"
              y="14"
              width={topPillWidth}
              height="4"
              rx="2"
              fill="#EDEFF6"
            />
            <rect x="8" y="22" width="148" height="4" rx="2" fill="#EDEFF6" />
          </g>
        ))}
      </svg>
    </Center>
  );
};
